import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "textpad" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("pre", null, [
      _createTextVNode(_toDisplayString($setup.texts), 1 /* TEXT */),
      _createVNode($setup["KeyStroke"]),
      _cache[0] || (_cache[0] = _createTextVNode("_", -1 /* CACHED */))
    ]),
    _createVNode($setup["Candidates"])
  ]))
}